// extracted by mini-css-extract-plugin
export default {"StudyModel":"R_kP7f4qYIj_Rl_s48zq"};